<template>
  <slot
    v-bind="{
      userPreferredRetailer,
      openRetailerDrawer,
      selectedRetailer,
      isRetailerDrawerVisible,
      hasPreferredUserRetailer,
      closeRetailerDrawer,
      showDeleteModal,
      closeDeleteModal,
      checkRideClubUser,
    }"
  ></slot>
</template>
<script>
import {PdlDialog} from '@pedal/pdl-dialog';
import {PdlButton} from '@pedal/pdl-button';
import RetailerDrawer from '../../drawer/retailer/RetailerDrawer.vue';
import UserOccApi from '@/api/user-occ.js';
import {PdlToastType} from '@/constants/pdl-toast-type.js';
import {mapActions, mapMutations, mapState} from 'vuex';
import SelectedRetailer from '@/components/cart/b2c/SelectedRetailer';

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    PdlDialog,
    PdlButton,
    RetailerDrawer,
    SelectedRetailer,
  },
  props: {
    isAccountSection: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isRetailerDrawerVisible: false,
      showDeleteModal: false,
    };
  },
  computed: {
    ...mapState('user', ['userPreferredRetailer', 'userProfile', 'selectedRetailer']),
    hasPreferredUserRetailer() {
      return Object.keys(this.userPreferredRetailer).length > 0;
    },
  },
  async mounted() {
    await this.fetchUserProfile();
    await this.fetchUserPreferredRetailer();
  },
  methods: {
    ...mapActions('user', ['fetchUserProfile', 'fetchUserPreferredRetailer']),
    ...mapMutations('user', ['setUserPreferredRetailer']),
    openRetailerDrawer() {
      this.isRetailerDrawerVisible = true;
    },
    closeRetailerDrawer() {
      this.isRetailerDrawerVisible = false;
    },
    checkRideClubUser() {
      if (this.userProfile?.rideClubAppFirstLogin) {
        this.showDeleteModal = true;
      } else {
        this.removeUserPreferredRetailer();
      }
    },
    closeDeleteModal() {
      this.showDeleteModal = false;
    },
    async removeUserPreferredRetailer() {
      const payloadObj = {
        preferredRetailerCode: '',
      };
      try {
        await UserOccApi.patchUserProfile(payloadObj);
        this.setUserPreferredRetailer({});
        this.$notify({
          type: PdlToastType.SUCCESS,
          message: this.$t('account.confirmation.preferredRetailer.removed'),
        });
      } catch (e) {
        this.$notify({
          type: PdlToastType.ERROR,
          message: this.$t('errorMessage.unableToProcess'),
        });
      } finally {
        this.closeDeleteModal();
      }
    },
  },
};
</script>
